export default function Hero() {
  const handleScrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] lg:min-h-[680px] flex items-center bg-background-50 pt-[72px]"
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-5 whitespace-nowrap">
              百万吃瓜群众聚集地
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              51吃瓜视频
              <br />
              <span className="text-primary-500">围观热门事件的首选社区</span>
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              汇聚全网最新八卦资讯，从51吃瓜大赛到暗网吃瓜独家爆料，从台北娜娜前线报道到八卦讨论区全民互动。每天10万+吃瓜群众在线围观，热门事件实时追踪，不错过任何一个精彩瞬间。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl text-primary-500">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">注册吃瓜群众</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl text-accent-500">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活围观用户</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl text-secondary-500">24h</div>
                <div className="text-xs text-foreground-500 mt-1">全天候实时更新</div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  handleScrollTo('#index');
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                立即围观热门事件
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  handleScrollTo('#ranking');
                }}
                className="w-full sm:w-auto px-8 py-3 border border-background-300 text-foreground-700 rounded-lg text-sm font-medium hover:bg-background-100 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                查看热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20illustration%20of%20a%20vibrant%20digital%20community%20hub%2C%20glowing%20coral%20and%20amber%20interconnected%20nodes%2C%20stylized%20social%20media%20bubbles%20with%20trending%20topics%2C%20modern%20minimalist%20geometric%20design%2C%20entertainment%20and%20gossip%20community%20aesthetic%2C%20warm%20gradient%20background%2C%20clean%20professional%20composition%2C%20engaging%20visual%20for%20website%20hero%20section&width=1200&height=900&seq=hero-main&orientation=landscape"
                alt="51吃瓜视频社区首页主视觉 - 热门八卦社区互动"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/15 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}